import roAditional from './languages/ro'
// import atAditional from './languages/at'
import deAditional from './languages/de'
import huAditional from './languages/hu'

const aditionals = {
  ro: roAditional,
  de: deAditional,  
  at: deAditional,   
  hu: huAditional   
}

export const createAditionalConfig = (country, contract, executantDetails, firmaMontajContract, aditionalExtra) => {
  const config = aditionals[country]
  
  if (!config) {
    throw new Error(`Aditional config for country '${country}' not found`)
  }
  
  return config.create(contract, executantDetails, firmaMontajContract, aditionalExtra)
}